import React, { useState } from 'react';
import { FiTrash2, FiEdit2 } from 'react-icons/fi';
import EditAmenity from './EditAmenityProvider'; // check path
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Card = styled.div`
  border: 1px solid #ccc;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background-color: #fdfdfd;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h4`
  color: #385963;
  margin: 0 0 0.5rem 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Comment = styled.p`
  margin: 0.5rem 0;
  font-style: italic;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const IconGroup = styled.div`
  display: flex;
  gap: 1rem;

  svg {
    cursor: pointer;
    font-size: 1.1rem;
  }

  .edit {
    color: #385963;
  }

  .delete {
    color: #e60000;
  }
`;

const SectionTitle = styled.h3`
  color: #385963;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const RequestsCard = ({ amenitiesReq, onEditAmenity }) => {
  const { i18n } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem('token');
  const [editingAmenity, setEditingAmenity] = useState(null);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this amenity?')) {
      try {
        await fetch(`${BASE_URL}Amenity/${id}`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${tokenString}`,
          },
        });
        window.location.reload();
      } catch (err) {
        console.error('Error deleting amenity:', err);
      }
    }
  };

  const handleSaved = () => {
    setEditingAmenity(null);
    window.location.reload();
  };

  if (editingAmenity) {
    return (
      <EditAmenity
        amenity={editingAmenity}
        onCancel={() => setEditingAmenity(null)}
        onSaved={handleSaved}
      />
    );
  }

  const pendingAmenities = amenitiesReq?.filter((a) => a.status === 0) || [];
  const forRevisionAmenities = amenitiesReq?.filter((a) => a.status === 3) || [];

  return (
    <div>
      <SectionTitle>{i18n.t('pending')}</SectionTitle>
      {pendingAmenities.length === 0 ? (
        <p>{i18n.t('noRequests')}</p>
      ) : (
        pendingAmenities.map((amenity) => (
          <Card key={`pending-${amenity.id}`}>
            <Header>
              <div>
                <Title>{amenity.name?.gr} / {amenity.name?.en}</Title>
                <Comment>
                  <strong>{i18n.t('adminComment')}:</strong> {amenity.comment || '—'}
                </Comment>
              </div>
              <IconGroup>
                <FiEdit2 className="edit" onClick={() => onEditAmenity?.(amenity)} />
                <FiTrash2 className="delete" onClick={() => handleDelete(amenity.id)} />
              </IconGroup>
            </Header>
          </Card>
        ))
      )}

      <SectionTitle>{i18n.t('forRevision')}</SectionTitle>
      {forRevisionAmenities.length === 0 ? (
        <p>{i18n.t('noRequests')}</p>
      ) : (
        forRevisionAmenities.map((amenity) => (
          <Card key={`forrevision-${amenity.id}`}>
            <Header>
              <div>
                <Title>{amenity.name?.gr} / {amenity.name?.en}</Title>
                <Comment>
                  <strong>{i18n.t('adminComment')}:</strong> {amenity.comment || '—'}
                </Comment>
              </div>
              <IconGroup>
                <FiEdit2 className="edit" onClick={() => onEditAmenity?.(amenity)} />
                <FiTrash2 className="delete" onClick={() => handleDelete(amenity.id)} />
              </IconGroup>
            </Header>
          </Card>
        ))
      )}
    </div>
  );
};

export default RequestsCard;
